// // import { useEffect, useState, useRef } from "react";
// // import { 
// //   GetDataFromApiWithParams, 
// //   ExecutePostWithParams 
// // } from "../../../../services/api/ExecuteApiRequests";
// // import IPDCFinalTable from "../../../../components/IPDCFinalTable";
// // import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent } from "@mui/material";
// // import { Check, Close, Download, TableChart } from "@mui/icons-material";

// // export default function AgreementVerificationPage() {
// //   const [agreements, setAgreements] = useState([]);
// //   const componentRef = useRef();
// //   const [selectedColumns, setSelectedColumns] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");

// //   useEffect(() => {
// //     fetchPendingAgreements();
// //   }, []);

// //   const fetchPendingAgreements = async () => {
// //     try {
// //       setLoading(true);
// //       setError("");
// //       console.log("Fetching pending agreements from API...");
      
// //       const resultRow = await GetDataFromApiWithParams("agreements/pending/approval");
// //       console.log("Pending Agreements API Response:", resultRow);
      
// //       if (resultRow && Array.isArray(resultRow)) {
// //         console.log(`Total pending agreements received: ${resultRow.length}`);
        
// //         if (resultRow.length > 0) {
// //           console.log("First pending agreement sample:", resultRow[0]);
          
// //           // Process the data to handle JSON fields
// //           const processedData = resultRow.map(item => ({
// //             ...item,
// //             // Handle late_charge_fee if it's a JSON string or object
// //             late_charge_fee_display: item.late_charge_fee ? 
// //               (typeof item.late_charge_fee === 'object' ? 
// //                 `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
// //                 item.late_charge_fee) : 
// //               '0%',
// //             // Handle market_destination if it's an array
// //             market_destination_display: Array.isArray(item.market_destination) ? 
// //               item.market_destination.join(', ') : 
// //               item.market_destination || '',
// //             // Handle intl_brands_link if it's an array
// //             intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
// //               item.intl_brands_link.join(', ') : 
// //               item.intl_brands_link || '',
// //           }));
          
// //           setAgreements(processedData);
          
// //           // Define columns to show - use display fields for JSON/Array data
// //           const importantColumns = [
// //             'id', 'agreement_id', 'company_name', 'contact_person', 
// //             'upin', 'investment_type', 'contract_status',
// //             'contract_issued_on', 'contract_period_in_months',
// //             'monthly_rent', 'employee_capacity',
// //             'production_capacity', 'export_capacity', 'security', 'advance_payment',
// //             'tin_no', 'park_name', 'ownership_type', 'payment_mode',
// //             'annual_mngmnt_service_fee', 'grace_period_ending_date', 
// //             'market_destination_display', 'disposal_method',
// //             'handover_date', 'rehandover_date', 'production_commencement_date', 
// //             'late_charge_fee_display'
// //           ];
          
// //           // Use important columns that actually exist in the processed data
// //           const availableColumns = importantColumns.filter(col => 
// //             processedData[0].hasOwnProperty(col)
// //           );
          
// //           console.log("Columns available for display:", availableColumns);
// //           setSelectedColumns([...availableColumns, 'actions']);
// //         } else {
// //           setAgreements([]);
// //           setError("No pending agreements found for approval.");
// //         }
// //       } else {
// //         setError("No agreement data received from API.");
// //       }
// //     } catch (err) {
// //       console.error("Error fetching pending agreements:", err);
// //       setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleVerification = async (agreement, action) => {
// //     try {
// //       const agreementId = agreement.id || agreement.agreement_id;
// //       if (!agreementId) {
// //         setError("Cannot verify: Agreement ID is missing");
// //         return;
// //       }

// //       const updateData = {
// //         agreement_id: agreementId,
// //         action: action,
// //         remarks: `Agreement ${action}ed by Operation Management Head`,
// //         verified_by: "operation_management_head",
// //       };

// //       console.log(`Sending ${action} for agreement:`, agreementId);
// //       const response = await ExecutePostWithParams("agreements/verify", updateData);
      
// //       if (response) {
// //         setAgreements(prev => prev.filter(item => 
// //           (item.id || item.agreement_id) !== agreementId
// //         ));
// //         setSuccess(`Agreement successfully ${action === "verify" ? "verified" : "rejected"}!`);
// //         setError("");
// //         setTimeout(() => setSuccess(""), 5000);
        
// //         console.log(`Agreement ${agreementId} ${action}ed successfully`);
// //       } else {
// //         setError(`Failed to ${action} agreement. Server returned no response.`);
// //         setSuccess("");
// //       }
// //     } catch (err) {
// //       console.error("Verification error:", err);
// //       setError(`Error: ${err.message || "Unknown error during verification"}`);
// //       setSuccess("");
// //     }
// //   };

// //   const handleExportToExcel = (agreement) => {
// //     try {
// //       // Create a clean copy without React components and processed display fields
// //       const exportData = { ...agreement };
      
// //       // Remove React components and display fields
// //       delete exportData.actions;
// //       delete exportData.market_destination_display;
// //       delete exportData.intl_brands_link_display;
// //       delete exportData.late_charge_fee_display;
      
// //       // Handle JSON fields for export
// //       if (exportData.late_charge_fee) {
// //         if (typeof exportData.late_charge_fee === 'object') {
// //           exportData.late_charge_fee = `${exportData.late_charge_fee.fee || 0}${exportData.late_charge_fee.rate_type || '%'}`;
// //         }
// //       }
      
// //       // Handle array fields for export
// //       if (Array.isArray(exportData.market_destination)) {
// //         exportData.market_destination = exportData.market_destination.join(', ');
// //       }
// //       if (Array.isArray(exportData.intl_brands_link)) {
// //         exportData.intl_brands_link = exportData.intl_brands_link.join(', ');
// //       }
      
// //       const headers = Object.keys(exportData).filter(key => 
// //         typeof exportData[key] !== 'object' || exportData[key] === null
// //       );
      
// //       const csvHeaders = headers.join(',');
// //       const csvRow = headers.map(header => {
// //         const value = exportData[header];
// //         if (value === null || value === undefined) return '';
// //         // Handle values that might contain commas by wrapping in quotes
// //         return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
// //       }).join(',');
      
// //       const csvContent = `${csvHeaders}\n${csvRow}`;
      
// //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
// //       const link = document.createElement('a');
// //       const url = URL.createObjectURL(blob);
      
// //       link.setAttribute('href', url);
// //       link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
// //       link.style.visibility = 'hidden';
      
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
      
// //       console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
// //     } catch (err) {
// //       console.error("Error exporting to Excel:", err);
// //       setError("Error exporting agreement data to Excel");
// //     }
// //   };

// //   const handleExportAllToExcel = () => {
// //     try {
// //       if (enhancedAgreements.length === 0) {
// //         setError("No data to export");
// //         return;
// //       }

// //       // Create export data without React components
// //       const exportData = enhancedAgreements.map(agreement => {
// //         const cleanData = { ...agreement };
        
// //         // Remove React components and display fields
// //         delete cleanData.actions;
// //         delete cleanData.market_destination_display;
// //         delete cleanData.intl_brands_link_display;
// //         delete cleanData.late_charge_fee_display;
        
// //         // Handle JSON fields
// //         if (cleanData.late_charge_fee) {
// //           if (typeof cleanData.late_charge_fee === 'object') {
// //             cleanData.late_charge_fee = `${cleanData.late_charge_fee.fee || 0}${cleanData.late_charge_fee.rate_type || '%'}`;
// //           }
// //         }
        
// //         // Handle array fields
// //         if (Array.isArray(cleanData.market_destination)) {
// //           cleanData.market_destination = cleanData.market_destination.join(', ');
// //         }
// //         if (Array.isArray(cleanData.intl_brands_link)) {
// //           cleanData.intl_brands_link = cleanData.intl_brands_link.join(', ');
// //         }
        
// //         return cleanData;
// //       });

// //       const headers = Object.keys(exportData[0]).filter(key => 
// //         typeof exportData[0][key] !== 'object' || exportData[0][key] === null
// //       );
      
// //       const csvHeaders = headers.join(',');
      
// //       const csvRows = exportData.map(item => {
// //         return headers.map(header => {
// //           const value = item[header];
// //           if (value === null || value === undefined) return '';
// //           return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
// //         }).join(',');
// //       }).join('\n');
      
// //       const csvContent = `${csvHeaders}\n${csvRows}`;
      
// //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
// //       const link = document.createElement('a');
// //       const url = URL.createObjectURL(blob);
      
// //       link.setAttribute('href', url);
// //       link.setAttribute('download', `all_pending_agreements_${new Date().toISOString().split('T')[0]}.csv`);
// //       link.style.visibility = 'hidden';
      
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
      
// //       console.log(`Exported all ${enhancedAgreements.length} agreements to Excel`);
// //       setSuccess(`All ${enhancedAgreements.length} agreements exported successfully!`);
// //       setTimeout(() => setSuccess(""), 5000);
// //     } catch (err) {
// //       console.error("Error exporting all to Excel:", err);
// //       setError("Error exporting all agreements data to Excel");
// //     }
// //   };

// //   // Enhanced agreements with action buttons and formatted display values
// //   const enhancedAgreements = agreements.map(agreement => {
// //     const agreementId = agreement.id || agreement.agreement_id;
// //     const status = agreement.contract_status || 'Pending';
    
// //     // Format late_charge_fee for display
// //     let lateChargeDisplay = '';
// //     if (agreement.late_charge_fee) {
// //       if (typeof agreement.late_charge_fee === 'object') {
// //         lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
// //       } else {
// //         lateChargeDisplay = agreement.late_charge_fee;
// //       }
// //     }
    
// //     return {
// //       ...agreement,
// //       id: agreementId,
// //       contract_status: status,
// //       // Use the display values instead of raw JSON/array data
// //       late_charge_fee: lateChargeDisplay,
// //       market_destination: agreement.market_destination_display || agreement.market_destination,
// //       intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
// //       actions: (
// //         <Box sx={{ 
// //           display: "flex", 
// //           gap: 1, 
// //           flexDirection: 'row',
// //           flexWrap: 'nowrap',
// //           justifyContent: 'center',
// //           alignItems: 'center'
// //         }}>
// //         <Button
// //           variant="outlined"
// //           size="small"
// //           startIcon={<Download />}
// //           onClick={() => handleExportToExcel(agreement)}
// //           disabled={!agreementId}
// //           sx={{ whiteSpace: 'nowrap' }}
// //         >
// //           Export
// //         </Button>
// //           <Button
// //             variant="contained"
// //             size="small"
// //             startIcon={<Check />}
// //             onClick={() => handleVerification(agreement, "verify")}
// //             disabled={!agreementId}
// //             sx={{ 
// //               whiteSpace: 'nowrap',
// //               backgroundColor: '#f5f5f5',
// //               color: '#000000',
// //               '&:hover': {
// //                 backgroundColor: '#e0e0e0',
// //               }
// //             }}
// //           >
// //             Verify
// //           </Button>
// //           <Button
// //             variant="contained"
// //             size="small"
// //             startIcon={<Close />}
// //             onClick={() => handleVerification(agreement, "reject")}
// //             disabled={!agreementId}
// //             sx={{ 
// //               whiteSpace: 'nowrap',
// //               backgroundColor: '#FFFafa',
// //               color: '#000000',
// //               '&:hover': {
// //                 backgroundColor: '#F08090',
// //               }
// //             }}
// // >
// //   Reject
// // </Button>
// //         </Box>
// //       )
// //     };
// //   });

// //   if (loading) {
// //     return (
// //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
// //         <CircularProgress />
// //         <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card>
// //         <CardContent>
// //           {error && (
// //             <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
// //               {error}
// //             </Alert>
// //           )}

// //           {success && (
// //             <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
// //               {success}
// //             </Alert>
// //           )}

// //           {enhancedAgreements.length > 0 ? (
// //             <>
// //               <IPDCFinalTable
// //                 ref={componentRef}
// //                 data={enhancedAgreements}
// //                 setData={setAgreements}
// //                 selectedColumns={selectedColumns}
// //                 title={`Pending Agreements for Approval (${enhancedAgreements.length})`}
// //                 hasAttachment={false}
// //               />
              
// //               <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
// //               <Button
// //                     variant="contained"
// //                     startIcon={<TableChart />}
// //                     onClick={handleExportAllToExcel}
// //                     disabled={enhancedAgreements.length === 0}
// //                     sx={{ 
// //                       whiteSpace: 'nowrap',
// //                       backgroundColor: '#f5f5f5',
// //                       color: '#000000',
// //                       '&:hover': {
// //                         backgroundColor: '#e0e0e0',
// //                       },
// //                       '&:disabled': {
// //                         backgroundColor: '#f5f5f5',
// //                         color: '#000000',
// //                         opacity: 0.5,
// //                       }
// //                     }}
// //                   >
// //                     Export All Data ({enhancedAgreements.length} rows)
// //                   </Button>
// //               </Box>
// //             </>
// //           ) : (
// //             !error && (
// //               <Box sx={{ p: 3, textAlign: 'center' }}>
// //                 <Typography variant="h6" color="textSecondary">
// //                   No pending agreements found for approval.
// //                 </Typography>
// //                 <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
// //                   All agreements have been processed or there are no agreements waiting for approval.
// //                 </Typography>
// //               </Box>
// //             )
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // }
// //****************************************************************************** */
// // import { useEffect, useState, useRef } from "react";
// // import { 
// //   GetDataFromApiWithParams, 
// //   ExecutePostWithParams 
// // } from "../../../../services/api/ExecuteApiRequests";
// // import IPDCFinalTable from "../../../../components/IPDCFinalTable";
// // import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent, Tabs, Tab } from "@mui/material";
// // import { Check, Close, Download, TableChart, History, Edit } from "@mui/icons-material";

// // export default function AgreementVerificationPage() {
// //   const [agreements, setAgreements] = useState([]);
// //   const [verifiedAgreements, setVerifiedAgreements] = useState([]);
// //   const [activeTab, setActiveTab] = useState(0);
// //   const componentRef = useRef();
// //   const [selectedColumns, setSelectedColumns] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [loadingHistory, setLoadingHistory] = useState(false);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");

// //   // Define important columns as a constant so it's available for both tabs
// //   const importantColumns = [
// //     'id', 'agreement_id', 'company_name', 'contact_person', 
// //     'upin', 'investment_type', 'status',
// //     'contract_issued_on', 'contract_period_in_months',
// //     'monthly_rent', 'employee_capacity',
// //     'production_capacity', 'export_capacity', 'security', 'advance_payment',
// //     'tin_no', 'park_name', 'ownership_type', 'payment_mode',
// //     'annual_mngmnt_service_fee', 'grace_period_ending_date', 
// //     'market_destination_display', 'disposal_method',
// //     'handover_date', 'rehandover_date', 'production_commencement_date', 
// //     'late_charge_fee_display'
// //   ];

// //   useEffect(() => {
// //     fetchPendingAgreements();
// //     fetchVerifiedAgreements();
// //   }, []);

// //   const fetchPendingAgreements = async () => {
// //     try {
// //       setLoading(true);
// //       setError("");
// //       console.log("Fetching pending agreements from API...");
      
// //       const resultRow = await GetDataFromApiWithParams("agreements/pending/approval");
// //       console.log("Pending Agreements API Response:", resultRow);
      
// //       if (resultRow && Array.isArray(resultRow)) {
// //         console.log(`Total pending agreements received: ${resultRow.length}`);
        
// //         if (resultRow.length > 0) {
// //           console.log("First pending agreement sample:", resultRow[0]);
          
// //           // Process the data to handle JSON fields
// //           const processedData = resultRow.map(item => ({
// //             ...item,
// //             // Handle late_charge_fee if it's a JSON string or object
// //             late_charge_fee_display: item.late_charge_fee ? 
// //               (typeof item.late_charge_fee === 'object' ? 
// //                 `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
// //                 item.late_charge_fee) : 
// //               '0%',
// //             // Handle market_destination if it's an array
// //             market_destination_display: Array.isArray(item.market_destination) ? 
// //               item.market_destination.join(', ') : 
// //               item.market_destination || '',
// //             // Handle intl_brands_link if it's an array
// //             intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
// //               item.intl_brands_link.join(', ') : 
// //               item.intl_brands_link || '',
// //           }));
          
// //           setAgreements(processedData);
          
// //           // Set columns based on first item
// //           const availableColumns = importantColumns.filter(col => 
// //             processedData[0].hasOwnProperty(col) || col === 'actions'
// //           );
          
// //           console.log("Columns available for display:", availableColumns);
// //           setSelectedColumns([...availableColumns, 'actions']);
// //         } else {
// //           setAgreements([]);
// //           // Don't set error here, just empty state
// //         }
// //       } else {
// //         setError("No agreement data received from API.");
// //       }
// //     } catch (err) {
// //       console.error("Error fetching pending agreements:", err);
// //       setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const fetchVerifiedAgreements = async () => {
// //     try {
// //       setLoadingHistory(true);
// //       console.log("Fetching verified agreements (waiting for approval) from API...");
      
// //       // Fetch agreements that are verified and waiting for approval
// //       const resultRow = await GetDataFromApiWithParams("agreements/waiting/approval");
// //       console.log("Verified Agreements (Waiting for Approval) API Response:", resultRow);
      
// //       if (resultRow && Array.isArray(resultRow)) {
// //         console.log(`Total verified agreements waiting for approval: ${resultRow.length}`);
        
// //         if (resultRow.length > 0) {
// //           console.log("First verified agreement sample:", resultRow[0]);
// //           console.log("Keys in verified agreement:", Object.keys(resultRow[0]));
          
// //           // Process the data to handle JSON fields
// //           const processedData = resultRow.map(item => ({
// //             ...item,
// //             late_charge_fee_display: item.late_charge_fee ? 
// //               (typeof item.late_charge_fee === 'object' ? 
// //                 `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
// //                 item.late_charge_fee) : 
// //               '0%',
// //             market_destination_display: Array.isArray(item.market_destination) ? 
// //               item.market_destination.join(', ') : 
// //               item.market_destination || '',
// //             intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
// //               item.intl_brands_link.join(', ') : 
// //               item.intl_brands_link || '',
// //           }));
          
// //           setVerifiedAgreements(processedData);
          
// //           // If columns not set yet, set them from verified agreements
// //           if (selectedColumns.length === 0) {
// //             const availableColumns = importantColumns.filter(col => 
// //               processedData[0].hasOwnProperty(col)
// //             );
// //             console.log("Setting columns from verified agreements:", availableColumns);
// //             setSelectedColumns([...availableColumns, 'actions']);
// //           }
// //         } else {
// //           setVerifiedAgreements([]);
// //         }
// //       } else {
// //         console.log("No verified agreements found or invalid response");
// //         setVerifiedAgreements([]);
// //       }
// //     } catch (err) {
// //       console.error("Error fetching verified agreements:", err);
// //       setVerifiedAgreements([]);
// //     } finally {
// //       setLoadingHistory(false);
// //     }
// //   };

// //   const handleVerification = async (agreement, action) => {
// //     try {
// //       const agreementId = agreement.id || agreement.agreement_id;
// //       if (!agreementId) {
// //         setError("Cannot verify: Agreement ID is missing");
// //         return;
// //       }

// //       const updateData = {
// //         agreement_id: agreementId,
// //         action: action,
// //         remarks: `Agreement ${action}ed by Operation Management Head`,
// //         verified_by: "operation_management_head",
// //       };

// //       console.log(`Sending ${action} for agreement:`, agreementId);
// //       const response = await ExecutePostWithParams("agreements/verify", updateData);
      
// //       if (response) {
// //         setAgreements(prev => prev.filter(item => 
// //           (item.id || item.agreement_id) !== agreementId
// //         ));
// //         setSuccess(`Agreement successfully ${action === "verify" ? "verified" : "rejected"}!`);
// //         setError("");
        
// //         // Refresh verified agreements list if verified
// //         if (action === "verify") {
// //           fetchVerifiedAgreements();
// //         }
        
// //         setTimeout(() => setSuccess(""), 5000);
        
// //         console.log(`Agreement ${agreementId} ${action}ed successfully`);
// //       } else {
// //         setError(`Failed to ${action} agreement. Server returned no response.`);
// //         setSuccess("");
// //       }
// //     } catch (err) {
// //       console.error("Verification error:", err);
// //       setError(`Error: ${err.message || "Unknown error during verification"}`);
// //       setSuccess("");
// //     }
// //   };

// //   // const handleAllowEdit = async (agreement) => {
// //   //   try {
// //   //     const agreementId = agreement.id || agreement.agreement_id;
// //   //     if (!agreementId) {
// //   //       setError("Cannot allow edit: Agreement ID is missing");
// //   //       return;
// //   //     }

// //   //     console.log(`Allowing edit for agreement: ${agreementId}`);
      
// //   //     // Update agreement status to 'Edit_allowed_to_expert'
// //   //     const updateData = {
// //   //       agreement_id: agreementId,
// //   //       action: "allow_edit",
// //   //       remarks: "Edit access granted to expert by Operation Management Head",
// //   //       verified_by: "operation_management_head",
// //   //     };

// //   //     const response = await ExecutePostWithParams("agreements/approve", updateData);
      
// //   //     if (response) {
// //   //       setVerifiedAgreements(prev => prev.filter(item => 
// //   //         (item.id || item.agreement_id) !== agreementId
// //   //       ));
// //   //       setSuccess(`Edit access granted for agreement ${agreementId}!`);
// //   //       setError("");
// //   //       setTimeout(() => setSuccess(""), 5000);
// //   //       console.log(`Edit allowed for agreement ${agreementId}`);
// //   //     } else {
// //   //       setError("Failed to allow edit. Please try again.");
// //   //       setSuccess("");
// //   //     }
// //   //   } catch (err) {
// //   //     console.error("Allow edit error:", err);
// //   //     setError(`Error: ${err.message || "Unknown error while allowing edit"}`);
// //   //     setSuccess("");
// //   //   }
// //   // };
// // //************************************************************************************** */
// // const handleAllowEdit = async (agreement) => {
// //   try {
// //     const agreementId = agreement.id || agreement.agreement_id;
// //     if (!agreementId) {
// //       setError("Cannot allow edit: Agreement ID is missing");
// //       return;
// //     }

// //     console.log(`Allowing edit for agreement: ${agreementId}`);
    
// //     const updateData = {
// //       agreement_id: agreementId,
// //       action: "allow_edit",
// //       remarks: "Edit access granted to expert by Operation Management Head",
// //       verified_by: "operation_management_head",
// //     };

// //     console.log("Sending allow_edit request:", updateData);
    
// //     const response = await ExecutePostWithParams("agreements/verify", updateData);
    
// //     if (response) {
// //       setVerifiedAgreements(prev => prev.filter(item => 
// //         (item.id || item.agreement_id) !== agreementId
// //       ));
// //       setSuccess(`Edit access granted for agreement ${agreementId}!`);
// //       setError("");
// //       setTimeout(() => setSuccess(""), 5000);
// //       console.log(`Edit allowed for agreement ${agreementId}`);
// //     } else {
// //       setError("Failed to allow edit. Please try again.");
// //       setSuccess("");
// //     }
// //   } catch (err) {
// //     console.error("Allow edit error:", err);
// //     setError(`Error: ${err.message || "Unknown error while allowing edit"}`);
// //     setSuccess("");
// //   }
// // };
// //   const handleExportToExcel = (agreement) => {
// //     try {
// //       // Create a clean copy without React components and processed display fields
// //       const exportData = { ...agreement };
      
// //       // Remove React components and display fields
// //       delete exportData.actions;
// //       delete exportData.market_destination_display;
// //       delete exportData.intl_brands_link_display;
// //       delete exportData.late_charge_fee_display;
      
// //       // Handle JSON fields for export
// //       if (exportData.late_charge_fee) {
// //         if (typeof exportData.late_charge_fee === 'object') {
// //           exportData.late_charge_fee = `${exportData.late_charge_fee.fee || 0}${exportData.late_charge_fee.rate_type || '%'}`;
// //         }
// //       }
      
// //       // Handle array fields for export
// //       if (Array.isArray(exportData.market_destination)) {
// //         exportData.market_destination = exportData.market_destination.join(', ');
// //       }
// //       if (Array.isArray(exportData.intl_brands_link)) {
// //         exportData.intl_brands_link = exportData.intl_brands_link.join(', ');
// //       }
      
// //       const headers = Object.keys(exportData).filter(key => 
// //         typeof exportData[key] !== 'object' || exportData[key] === null
// //       );
      
// //       const csvHeaders = headers.join(',');
// //       const csvRow = headers.map(header => {
// //         const value = exportData[header];
// //         if (value === null || value === undefined) return '';
// //         // Handle values that might contain commas by wrapping in quotes
// //         return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
// //       }).join(',');
      
// //       const csvContent = `${csvHeaders}\n${csvRow}`;
      
// //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
// //       const link = document.createElement('a');
// //       const url = URL.createObjectURL(blob);
      
// //       link.setAttribute('href', url);
// //       link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
// //       link.style.visibility = 'hidden';
      
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
      
// //       console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
// //     } catch (err) {
// //       console.error("Error exporting to Excel:", err);
// //       setError("Error exporting agreement data to Excel");
// //     }
// //   };

// //   const handleExportAllToExcel = () => {
// //     try {
// //       const dataToExport = activeTab === 0 ? enhancedAgreements : enhancedVerifiedAgreements;
      
// //       if (dataToExport.length === 0) {
// //         setError("No data to export");
// //         return;
// //       }

// //       // Create export data without React components
// //       const exportData = dataToExport.map(agreement => {
// //         const cleanData = { ...agreement };
        
// //         // Remove React components and display fields
// //         delete cleanData.actions;
// //         delete cleanData.market_destination_display;
// //         delete cleanData.intl_brands_link_display;
// //         delete cleanData.late_charge_fee_display;
        
// //         // Handle JSON fields
// //         if (cleanData.late_charge_fee) {
// //           if (typeof cleanData.late_charge_fee === 'object') {
// //             cleanData.late_charge_fee = `${cleanData.late_charge_fee.fee || 0}${cleanData.late_charge_fee.rate_type || '%'}`;
// //           }
// //         }
        
// //         // Handle array fields
// //         if (Array.isArray(cleanData.market_destination)) {
// //           cleanData.market_destination = cleanData.market_destination.join(', ');
// //         }
// //         if (Array.isArray(cleanData.intl_brands_link)) {
// //           cleanData.intl_brands_link = cleanData.intl_brands_link.join(', ');
// //         }
        
// //         return cleanData;
// //       });

// //       const headers = Object.keys(exportData[0]).filter(key => 
// //         typeof exportData[0][key] !== 'object' || exportData[0][key] === null
// //       );
      
// //       const csvHeaders = headers.join(',');
      
// //       const csvRows = exportData.map(item => {
// //         return headers.map(header => {
// //           const value = item[header];
// //           if (value === null || value === undefined) return '';
// //           return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
// //         }).join(',');
// //       }).join('\n');
      
// //       const csvContent = `${csvHeaders}\n${csvRows}`;
      
// //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
// //       const link = document.createElement('a');
// //       const url = URL.createObjectURL(blob);
      
// //       const tabLabel = activeTab === 0 ? 'pending' : 'verified_waiting_approval';
// //       link.setAttribute('href', url);
// //       link.setAttribute('download', `all_${tabLabel}_agreements_${new Date().toISOString().split('T')[0]}.csv`);
// //       link.style.visibility = 'hidden';
      
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
      
// //       console.log(`Exported all ${dataToExport.length} agreements to Excel`);
// //       setSuccess(`All ${dataToExport.length} agreements exported successfully!`);
// //       setTimeout(() => setSuccess(""), 5000);
// //     } catch (err) {
// //       console.error("Error exporting all to Excel:", err);
// //       setError("Error exporting all agreements data to Excel");
// //     }
// //   };

// //   // Enhanced agreements with action buttons and formatted display values
// //   const enhancedAgreements = agreements.map(agreement => {
// //     const agreementId = agreement.id || agreement.agreement_id;
// //     const status = agreement.status || agreement.contract_status || 'Pending';
    
// //     // Format late_charge_fee for display
// //     let lateChargeDisplay = '';
// //     if (agreement.late_charge_fee) {
// //       if (typeof agreement.late_charge_fee === 'object') {
// //         lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
// //       } else {
// //         lateChargeDisplay = agreement.late_charge_fee;
// //       }
// //     }
    
// //     return {
// //       ...agreement,
// //       id: agreementId,
// //       status: status,
// //       // Use the display values instead of raw JSON/array data
// //       late_charge_fee: lateChargeDisplay,
// //       market_destination: agreement.market_destination_display || agreement.market_destination,
// //       intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
// //       actions: (
// //         <Box sx={{ 
// //           display: "flex", 
// //           gap: 1, 
// //           flexDirection: 'row',
// //           flexWrap: 'nowrap',
// //           justifyContent: 'center',
// //           alignItems: 'center'
// //         }}>
// //         <Button
// //           variant="outlined"
// //           size="small"
// //           startIcon={<Download />}
// //           onClick={() => handleExportToExcel(agreement)}
// //           disabled={!agreementId}
// //           sx={{ whiteSpace: 'nowrap' }}
// //         >
// //           Export
// //         </Button>
// //           <Button
// //             variant="contained"
// //             size="small"
// //             startIcon={<Check />}
// //             onClick={() => handleVerification(agreement, "verify")}
// //             disabled={!agreementId}
// //             sx={{ 
// //               whiteSpace: 'nowrap',
// //               backgroundColor: '#f5f5f5',
// //               color: '#000000',
// //               '&:hover': {
// //                 backgroundColor: '#e0e0e0',
// //               }
// //             }}
// //           >
// //             Verify
// //           </Button>
// //           <Button
// //             variant="contained"
// //             size="small"
// //             startIcon={<Close />}
// //             onClick={() => handleVerification(agreement, "reject")}
// //             disabled={!agreementId}
// //             sx={{ 
// //               whiteSpace: 'nowrap',
// //               backgroundColor: '#FFFafa',
// //               color: '#000000',
// //               '&:hover': {
// //                 backgroundColor: '#F08090',
// //               }
// //             }}
// //           >
// //             Reject
// //           </Button>
// //         </Box>
// //       )
// //     };
// //   });

// //   // Enhanced verified agreements with action buttons
// //   const enhancedVerifiedAgreements = verifiedAgreements.map(agreement => {
// //     const agreementId = agreement.id || agreement.agreement_id;
    
// //     // Format late_charge_fee for display
// //     let lateChargeDisplay = '';
// //     if (agreement.late_charge_fee) {
// //       if (typeof agreement.late_charge_fee === 'object') {
// //         lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
// //       } else {
// //         lateChargeDisplay = agreement.late_charge_fee;
// //       }
// //     }
    
// //     return {
// //       ...agreement,
// //       id: agreementId,
// //       late_charge_fee: lateChargeDisplay,
// //       market_destination: agreement.market_destination_display || agreement.market_destination,
// //       intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
// //       actions: (
// //         <Box sx={{ 
// //           display: "flex", 
// //           gap: 1, 
// //           flexDirection: 'row',
// //           flexWrap: 'nowrap',
// //           justifyContent: 'center',
// //           alignItems: 'center'
// //         }}>
// //           {/* <Button
// //             variant="outlined"
// //             size="small"
// //             startIcon={<Download />}
// //             onClick={() => handleExportToExcel(agreement)}
// //             disabled={!agreementId}
// //             sx={{ whiteSpace: 'nowrap' }}
// //           >
// //             Export
// //           </Button> */}
// //           <Button
// //             variant="contained"
// //             size="small"
// //             startIcon={<Edit />}
// //             onClick={() => handleAllowEdit(agreement)}
// //             disabled={!agreementId}
// //             sx={{ 
// //               whiteSpace: 'nowrap',
// //               backgroundColor: '#4caf50',
// //               color: '#ffffff',
// //               '&:hover': {
// //                 backgroundColor: '#388e3c',
// //               }
// //             }}
// //           >
// //             Allow Edit
// //           </Button>
// //         </Box>
// //       )
// //     };
// //   });

// //   const handleTabChange = (event, newValue) => {
// //     setActiveTab(newValue);
// //     setError("");
// //     setSuccess("");
// //   };

// //   if (loading) {
// //     return (
// //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
// //         <CircularProgress />
// //         <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card>
// //         <CardContent>
// //           {error && (
// //             <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
// //               {error}
// //             </Alert>
// //           )}

// //           {success && (
// //             <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
// //               {success}
// //             </Alert>
// //           )}

// //           <Tabs 
// //             value={activeTab} 
// //             onChange={handleTabChange}
// //             sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
// //           >
// //             <Tab 
// //               icon={<Check />} 
// //               iconPosition="start" 
// //               label={`Pending Verification (${enhancedAgreements.length})`} 
// //             />
// //             <Tab 
// //               icon={<History />} 
// //               iconPosition="start" 
// //               label={`Verified - Waiting Approval (${enhancedVerifiedAgreements.length})`} 
// //             />
// //           </Tabs>

// //           {activeTab === 0 && (
// //             <>
// //               {enhancedAgreements.length > 0 ? (
// //                 <>
// //                   <IPDCFinalTable
// //                     ref={componentRef}
// //                     data={enhancedAgreements}
// //                     setData={setAgreements}
// //                     selectedColumns={selectedColumns.length > 0 ? selectedColumns : importantColumns.filter(col => enhancedAgreements[0]?.hasOwnProperty(col)).concat('actions')}
// //                     title={`Pending Agreements for Verification (${enhancedAgreements.length})`}
// //                     hasAttachment={false}
// //                   />
                  
// //                   <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
// //                     <Button
// //                       variant="contained"
// //                       startIcon={<TableChart />}
// //                       onClick={handleExportAllToExcel}
// //                       disabled={enhancedAgreements.length === 0}
// //                       sx={{ 
// //                         whiteSpace: 'nowrap',
// //                         backgroundColor: '#f5f5f5',
// //                         color: '#000000',
// //                         '&:hover': {
// //                           backgroundColor: '#e0e0e0',
// //                         },
// //                         '&:disabled': {
// //                           backgroundColor: '#f5f5f5',
// //                           color: '#000000',
// //                           opacity: 0.5,
// //                         }
// //                       }}
// //                     >
// //                       Export All Data ({enhancedAgreements.length} rows)
// //                     </Button>
// //                   </Box>
// //                 </>
// //               ) : (
// //                 !error && (
// //                   <Box sx={{ p: 3, textAlign: 'center' }}>
// //                     <Typography variant="h6" color="textSecondary">
// //                       No pending agreements found for verification.
// //                     </Typography>
// //                     <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
// //                       All agreements have been processed or there are no agreements waiting for verification.
// //                     </Typography>
// //                   </Box>
// //                 )
// //               )}
// //             </>
// //           )}

// //           {activeTab === 1 && (
// //             <>
// //               {loadingHistory ? (
// //                 <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
// //                   <CircularProgress />
// //                   <Typography sx={{ ml: 2 }}>Loading verified agreements...</Typography>
// //                 </Box>
// //               ) : enhancedVerifiedAgreements.length > 0 ? (
// //                 <>
// //                   <IPDCFinalTable
// //                     ref={componentRef}
// //                     data={enhancedVerifiedAgreements}
// //                     setData={setVerifiedAgreements}
// //                     selectedColumns={selectedColumns.length > 0 ? selectedColumns : importantColumns.filter(col => enhancedVerifiedAgreements[0]?.hasOwnProperty(col)).concat('actions')}
// //                     title={`Verified Agreements - Waiting for Approval (${enhancedVerifiedAgreements.length})`}
// //                     hasAttachment={false}
// //                   />
                  
// //                   <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
// //                     <Button
// //                       variant="contained"
// //                       startIcon={<TableChart />}
// //                       onClick={handleExportAllToExcel}
// //                       disabled={enhancedVerifiedAgreements.length === 0}
// //                       sx={{ 
// //                         whiteSpace: 'nowrap',
// //                         backgroundColor: '#f5f5f5',
// //                         color: '#000000',
// //                         '&:hover': {
// //                           backgroundColor: '#e0e0e0',
// //                         },
// //                         '&:disabled': {
// //                           backgroundColor: '#f5f5f5',
// //                           color: '#000000',
// //                           opacity: 0.5,
// //                         }
// //                       }}
// //                     >
// //                       Export All Data ({enhancedVerifiedAgreements.length} rows)
// //                     </Button>
// //                   </Box>
// //                 </>
// //               ) : (
// //                 <Box sx={{ p: 3, textAlign: 'center' }}>
// //                   <Typography variant="h6" color="textSecondary">
// //                     No verified agreements waiting for approval.
// //                   </Typography>
// //                   <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
// //                     Verified agreements waiting for approval will appear here.
// //                   </Typography>
// //                 </Box>
// //               )}
// //             </>
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // }
// //*************************************************************************** */
// //************************************************************************** */
// import { useEffect, useState, useRef } from "react";
// import { 
//   GetDataFromApiWithParams, 
//   ExecutePostWithParams 
// } from "../../../../services/api/ExecuteApiRequests";
// import IPDCFinalTable from "../../../../components/IPDCFinalTable";
// import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
// import { Check, Close, Download, TableChart, History, Edit } from "@mui/icons-material";

// export default function AgreementVerificationPage() {
//   const [agreements, setAgreements] = useState([]);
//   const [verifiedAgreements, setVerifiedAgreements] = useState([]);
//   const [activeTab, setActiveTab] = useState(0);
//   const componentRef = useRef();
//   const [selectedColumns, setSelectedColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingHistory, setLoadingHistory] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
  
//   // Reject modal state
//   const [rejectModalOpen, setRejectModalOpen] = useState(false);
//   const [rejectingAgreement, setRejectingAgreement] = useState(null);
//   const [rejectJustification, setRejectJustification] = useState("");
//   const [rejectJustificationError, setRejectJustificationError] = useState(false);
//   const [isSubmittingReject, setIsSubmittingReject] = useState(false);

//   // Define important columns as a constant so it's available for both tabs
//   const importantColumns = [
//     'id', 'agreement_id', 'company_name', 'contact_person', 
//     'upin', 'investment_type', 'status',
//     'contract_issued_on', 'contract_period_in_months',
//     'monthly_rent', 'employee_capacity',
//     'production_capacity', 'export_capacity', 'security', 'advance_payment',
//     'tin_no', 'park_name', 'ownership_type', 'payment_mode',
//     'annual_mngmnt_service_fee', 'grace_period_ending_date', 
//     'market_destination_display', 'disposal_method',
//     'handover_date', 'rehandover_date', 'production_commencement_date', 
//     'late_charge_fee_display'
//   ];

//   useEffect(() => {
//     fetchPendingAgreements();
//     fetchVerifiedAgreements();
//   }, []);

//   const fetchPendingAgreements = async () => {
//     try {
//       setLoading(true);
//       setError("");
//       console.log("Fetching pending agreements from API...");
      
//       const resultRow = await GetDataFromApiWithParams("agreements/pending/approval");
//       console.log("Pending Agreements API Response:", resultRow);
      
//       if (resultRow && Array.isArray(resultRow)) {
//         console.log(`Total pending agreements received: ${resultRow.length}`);
        
//         if (resultRow.length > 0) {
//           console.log("First pending agreement sample:", resultRow[0]);
          
//           // Process the data to handle JSON fields
//           const processedData = resultRow.map(item => ({
//             ...item,
//             // Handle late_charge_fee if it's a JSON string or object
//             late_charge_fee_display: item.late_charge_fee ? 
//               (typeof item.late_charge_fee === 'object' ? 
//                 `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
//                 item.late_charge_fee) : 
//               '0%',
//             // Handle market_destination if it's an array
//             market_destination_display: Array.isArray(item.market_destination) ? 
//               item.market_destination.join(', ') : 
//               item.market_destination || '',
//             // Handle intl_brands_link if it's an array
//             intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
//               item.intl_brands_link.join(', ') : 
//               item.intl_brands_link || '',
//           }));
          
//           setAgreements(processedData);
          
//           // Set columns based on first item
//           const availableColumns = importantColumns.filter(col => 
//             processedData[0].hasOwnProperty(col) || col === 'actions'
//           );
          
//           console.log("Columns available for display:", availableColumns);
//           setSelectedColumns([...availableColumns, 'actions']);
//         } else {
//           setAgreements([]);
//           // Don't set error here, just empty state
//         }
//       } else {
//         setError("No agreement data received from API.");
//       }
//     } catch (err) {
//       console.error("Error fetching pending agreements:", err);
//       setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchVerifiedAgreements = async () => {
//     try {
//       setLoadingHistory(true);
//       console.log("Fetching verified agreements (waiting for approval) from API...");
      
//       // Fetch agreements that are verified and waiting for approval
//       const resultRow = await GetDataFromApiWithParams("agreements/waiting/approval");
//       console.log("Verified Agreements (Waiting for Approval) API Response:", resultRow);
      
//       if (resultRow && Array.isArray(resultRow)) {
//         console.log(`Total verified agreements waiting for approval: ${resultRow.length}`);
        
//         if (resultRow.length > 0) {
//           console.log("First verified agreement sample:", resultRow[0]);
//           console.log("Keys in verified agreement:", Object.keys(resultRow[0]));
          
//           // Process the data to handle JSON fields
//           const processedData = resultRow.map(item => ({
//             ...item,
//             late_charge_fee_display: item.late_charge_fee ? 
//               (typeof item.late_charge_fee === 'object' ? 
//                 `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
//                 item.late_charge_fee) : 
//               '0%',
//             market_destination_display: Array.isArray(item.market_destination) ? 
//               item.market_destination.join(', ') : 
//               item.market_destination || '',
//             intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
//               item.intl_brands_link.join(', ') : 
//               item.intl_brands_link || '',
//           }));
          
//           setVerifiedAgreements(processedData);
          
//           // If columns not set yet, set them from verified agreements
//           if (selectedColumns.length === 0) {
//             const availableColumns = importantColumns.filter(col => 
//               processedData[0].hasOwnProperty(col)
//             );
//             console.log("Setting columns from verified agreements:", availableColumns);
//             setSelectedColumns([...availableColumns, 'actions']);
//           }
//         } else {
//           setVerifiedAgreements([]);
//         }
//       } else {
//         console.log("No verified agreements found or invalid response");
//         setVerifiedAgreements([]);
//       }
//     } catch (err) {
//       console.error("Error fetching verified agreements:", err);
//       setVerifiedAgreements([]);
//     } finally {
//       setLoadingHistory(false);
//     }
//   };

//   // Open reject modal with justification form
//   const handleOpenRejectModal = (agreement) => {
//     setRejectingAgreement(agreement);
//     setRejectJustification("");
//     setRejectJustificationError(false);
//     setRejectModalOpen(true);
//   };

//   // Close reject modal
//   const handleCloseRejectModal = () => {
//     setRejectModalOpen(false);
//     setRejectingAgreement(null);
//     setRejectJustification("");
//     setRejectJustificationError(false);
//     setIsSubmittingReject(false);
//   };

//   // Submit rejection with justification
//   const handleSubmitRejection = async () => {
//     // Validate justification
//     if (!rejectJustification.trim()) {
//       setRejectJustificationError(true);
//       return;
//     }

//     setRejectJustificationError(false);
//     setIsSubmittingReject(true);

//     try {
//       const agreementId = rejectingAgreement.id || rejectingAgreement.agreement_id;
//       if (!agreementId) {
//         setError("Cannot reject: Agreement ID is missing");
//         handleCloseRejectModal();
//         return;
//       }

//       // Combine existing description with rejection justification
//       const existingDescription = rejectingAgreement.description || "";
//       const rejectionNote = `[REJECTED By Head ON ${new Date().toLocaleString()}] Reason: ${rejectJustification.trim()} ]`;
//       const updatedDescription = existingDescription 
//         ? `${existingDescription}\n\n${rejectionNote}`
//         : rejectionNote;

//       const updateData = {
//         agreement_id: agreementId,
//         action: "reject",
//         remarks: `Agreement rejected by Operation Management Head. Reason: ${rejectJustification.trim()}`,
//         verified_by: "operation_management_head",
//         description: updatedDescription  // Add the description to be updated
//       };

//       console.log(`Sending reject with justification for agreement:`, agreementId);
//       console.log("Update data:", updateData);
      
//       const response = await ExecutePostWithParams("agreements/verify", updateData);
      
//       if (response) {
//         // Remove the rejected agreement from the list
//         setAgreements(prev => prev.filter(item => 
//           (item.id || item.agreement_id) !== agreementId
//         ));
//         setSuccess(`Agreement successfully rejected! Justification saved to description.`);
//         setError("");
        
//         setTimeout(() => setSuccess(""), 5000);
//         console.log(`Agreement ${agreementId} rejected successfully with justification`);
        
//         // Close modal
//         handleCloseRejectModal();
//       } else {
//         setError("Failed to reject agreement. Server returned no response.");
//         setSuccess("");
//       }
//     } catch (err) {
//       console.error("Rejection error:", err);
//       setError(`Error: ${err.message || "Unknown error during rejection"}`);
//       setSuccess("");
//     } finally {
//       setIsSubmittingReject(false);
//     }
//   };

//   const handleVerification = async (agreement, action) => {
//     try {
//       const agreementId = agreement.id || agreement.agreement_id;
//       if (!agreementId) {
//         setError("Cannot verify: Agreement ID is missing");
//         return;
//       }

//       const updateData = {
//         agreement_id: agreementId,
//         action: action,
//         remarks: `Agreement ${action}ed by Operation Management Head`,
//         verified_by: "operation_management_head",
//       };

//       console.log(`Sending ${action} for agreement:`, agreementId);
//       const response = await ExecutePostWithParams("agreements/verify", updateData);
      
//       if (response) {
//         setAgreements(prev => prev.filter(item => 
//           (item.id || item.agreement_id) !== agreementId
//         ));
//         setSuccess(`Agreement successfully ${action === "verify" ? "verified" : "rejected"}!`);
//         setError("");
        
//         // Refresh verified agreements list if verified
//         if (action === "verify") {
//           fetchVerifiedAgreements();
//         }
        
//         setTimeout(() => setSuccess(""), 5000);
        
//         console.log(`Agreement ${agreementId} ${action}ed successfully`);
//       } else {
//         setError(`Failed to ${action} agreement. Server returned no response.`);
//         setSuccess("");
//       }
//     } catch (err) {
//       console.error("Verification error:", err);
//       setError(`Error: ${err.message || "Unknown error during verification"}`);
//       setSuccess("");
//     }
//   };

//   const handleAllowEdit = async (agreement) => {
//     try {
//       const agreementId = agreement.id || agreement.agreement_id;
//       if (!agreementId) {
//         setError("Cannot allow edit: Agreement ID is missing");
//         return;
//       }

//       console.log(`Allowing edit for agreement: ${agreementId}`);
      
//       const updateData = {
//         agreement_id: agreementId,
//         action: "allow_edit",
//         remarks: "Edit access granted to expert by Operation Management Head",
//         verified_by: "operation_management_head",
//       };

//       console.log("Sending allow_edit request:", updateData);
      
//       const response = await ExecutePostWithParams("agreements/verify", updateData);
      
//       if (response) {
//         setVerifiedAgreements(prev => prev.filter(item => 
//           (item.id || item.agreement_id) !== agreementId
//         ));
//         setSuccess(`Edit access granted for agreement ${agreementId}!`);
//         setError("");
//         setTimeout(() => setSuccess(""), 5000);
//         console.log(`Edit allowed for agreement ${agreementId}`);
//       } else {
//         setError("Failed to allow edit. Please try again.");
//         setSuccess("");
//       }
//     } catch (err) {
//       console.error("Allow edit error:", err);
//       setError(`Error: ${err.message || "Unknown error while allowing edit"}`);
//       setSuccess("");
//     }
//   };

//   const handleExportToExcel = (agreement) => {
//     try {
//       // Create a clean copy without React components and processed display fields
//       const exportData = { ...agreement };
      
//       // Remove React components and display fields
//       delete exportData.actions;
//       delete exportData.market_destination_display;
//       delete exportData.intl_brands_link_display;
//       delete exportData.late_charge_fee_display;
      
//       // Handle JSON fields for export
//       if (exportData.late_charge_fee) {
//         if (typeof exportData.late_charge_fee === 'object') {
//           exportData.late_charge_fee = `${exportData.late_charge_fee.fee || 0}${exportData.late_charge_fee.rate_type || '%'}`;
//         }
//       }
      
//       // Handle array fields for export
//       if (Array.isArray(exportData.market_destination)) {
//         exportData.market_destination = exportData.market_destination.join(', ');
//       }
//       if (Array.isArray(exportData.intl_brands_link)) {
//         exportData.intl_brands_link = exportData.intl_brands_link.join(', ');
//       }
      
//       const headers = Object.keys(exportData).filter(key => 
//         typeof exportData[key] !== 'object' || exportData[key] === null
//       );
      
//       const csvHeaders = headers.join(',');
//       const csvRow = headers.map(header => {
//         const value = exportData[header];
//         if (value === null || value === undefined) return '';
//         // Handle values that might contain commas by wrapping in quotes
//         return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
//       }).join(',');
      
//       const csvContent = `${csvHeaders}\n${csvRow}`;
      
//       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//       const link = document.createElement('a');
//       const url = URL.createObjectURL(blob);
      
//       link.setAttribute('href', url);
//       link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
//       link.style.visibility = 'hidden';
      
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
//     } catch (err) {
//       console.error("Error exporting to Excel:", err);
//       setError("Error exporting agreement data to Excel");
//     }
//   };

//   const handleExportAllToExcel = () => {
//     try {
//       const dataToExport = activeTab === 0 ? enhancedAgreements : enhancedVerifiedAgreements;
      
//       if (dataToExport.length === 0) {
//         setError("No data to export");
//         return;
//       }

//       // Create export data without React components
//       const exportData = dataToExport.map(agreement => {
//         const cleanData = { ...agreement };
        
//         // Remove React components and display fields
//         delete cleanData.actions;
//         delete cleanData.market_destination_display;
//         delete cleanData.intl_brands_link_display;
//         delete cleanData.late_charge_fee_display;
        
//         // Handle JSON fields
//         if (cleanData.late_charge_fee) {
//           if (typeof cleanData.late_charge_fee === 'object') {
//             cleanData.late_charge_fee = `${cleanData.late_charge_fee.fee || 0}${cleanData.late_charge_fee.rate_type || '%'}`;
//           }
//         }
        
//         // Handle array fields
//         if (Array.isArray(cleanData.market_destination)) {
//           cleanData.market_destination = cleanData.market_destination.join(', ');
//         }
//         if (Array.isArray(cleanData.intl_brands_link)) {
//           cleanData.intl_brands_link = cleanData.intl_brands_link.join(', ');
//         }
        
//         return cleanData;
//       });

//       const headers = Object.keys(exportData[0]).filter(key => 
//         typeof exportData[0][key] !== 'object' || exportData[0][key] === null
//       );
      
//       const csvHeaders = headers.join(',');
      
//       const csvRows = exportData.map(item => {
//         return headers.map(header => {
//           const value = item[header];
//           if (value === null || value === undefined) return '';
//           return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
//         }).join(',');
//       }).join('\n');
      
//       const csvContent = `${csvHeaders}\n${csvRows}`;
      
//       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//       const link = document.createElement('a');
//       const url = URL.createObjectURL(blob);
      
//       const tabLabel = activeTab === 0 ? 'pending' : 'verified_waiting_approval';
//       link.setAttribute('href', url);
//       link.setAttribute('download', `all_${tabLabel}_agreements_${new Date().toISOString().split('T')[0]}.csv`);
//       link.style.visibility = 'hidden';
      
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       console.log(`Exported all ${dataToExport.length} agreements to Excel`);
//       setSuccess(`All ${dataToExport.length} agreements exported successfully!`);
//       setTimeout(() => setSuccess(""), 5000);
//     } catch (err) {
//       console.error("Error exporting all to Excel:", err);
//       setError("Error exporting all agreements data to Excel");
//     }
//   };

//   // Enhanced agreements with action buttons and formatted display values
//   const enhancedAgreements = agreements.map(agreement => {
//     const agreementId = agreement.id || agreement.agreement_id;
//     const status = agreement.status || agreement.contract_status || 'Pending';
    
//     // Format late_charge_fee for display
//     let lateChargeDisplay = '';
//     if (agreement.late_charge_fee) {
//       if (typeof agreement.late_charge_fee === 'object') {
//         lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
//       } else {
//         lateChargeDisplay = agreement.late_charge_fee;
//       }
//     }
    
//     return {
//       ...agreement,
//       id: agreementId,
//       status: status,
//       // Use the display values instead of raw JSON/array data
//       late_charge_fee: lateChargeDisplay,
//       market_destination: agreement.market_destination_display || agreement.market_destination,
//       intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
//       actions: (
//         <Box sx={{ 
//           display: "flex", 
//           gap: 1, 
//           flexDirection: 'row',
//           flexWrap: 'nowrap',
//           justifyContent: 'center',
//           alignItems: 'center'
//         }}>
//           <Button
//             variant="outlined"
//             size="small"
//             startIcon={<Download />}
//             onClick={() => handleExportToExcel(agreement)}
//             disabled={!agreementId}
//             sx={{ whiteSpace: 'nowrap' }}
//           >
//             Export
//           </Button>
//           <Button
//             variant="contained"
//             size="small"
//             startIcon={<Check />}
//             onClick={() => handleVerification(agreement, "verify")}
//             disabled={!agreementId}
//             sx={{ 
//               whiteSpace: 'nowrap',
//               backgroundColor: '#f5f5f5',
//               color: '#000000',
//               '&:hover': {
//                 backgroundColor: '#e0e0e0',
//               }
//             }}
//           >
//             Verify
//           </Button>
//           <Button
//             variant="contained"
//             size="small"
//             startIcon={<Close />}
//             onClick={() => handleOpenRejectModal(agreement)}
//             disabled={!agreementId}
//             sx={{ 
//               whiteSpace: 'nowrap',
//               backgroundColor: '#FFFafa',
//               color: '#000000',
//               '&:hover': {
//                 backgroundColor: '#F08090',
//               }
//             }}
//           >
//             Reject
//           </Button>
//         </Box>
//       )
//     };
//   });

//   // Enhanced verified agreements with action buttons
//   const enhancedVerifiedAgreements = verifiedAgreements.map(agreement => {
//     const agreementId = agreement.id || agreement.agreement_id;
    
//     // Format late_charge_fee for display
//     let lateChargeDisplay = '';
//     if (agreement.late_charge_fee) {
//       if (typeof agreement.late_charge_fee === 'object') {
//         lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
//       } else {
//         lateChargeDisplay = agreement.late_charge_fee;
//       }
//     }
    
//     return {
//       ...agreement,
//       id: agreementId,
//       late_charge_fee: lateChargeDisplay,
//       market_destination: agreement.market_destination_display || agreement.market_destination,
//       intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
//       actions: (
//         <Box sx={{ 
//           display: "flex", 
//           gap: 1, 
//           flexDirection: 'row',
//           flexWrap: 'nowrap',
//           justifyContent: 'center',
//           alignItems: 'center'
//         }}>
//           <Button
//             variant="contained"
//             size="small"
//             startIcon={<Edit />}
//             onClick={() => handleAllowEdit(agreement)}
//             disabled={!agreementId}
//             sx={{ 
//               whiteSpace: 'nowrap',
//               backgroundColor: '#4caf50',
//               color: '#ffffff',
//               '&:hover': {
//                 backgroundColor: '#388e3c',
//               }
//             }}
//           >
//             Allow Edit
//           </Button>
//         </Box>
//       )
//     };
//   });

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//     setError("");
//     setSuccess("");
//   };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//         <CircularProgress />
//         <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card>
//         <CardContent>
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
//               {error}
//             </Alert>
//           )}

//           {success && (
//             <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
//               {success}
//             </Alert>
//           )}

//           <Tabs 
//             value={activeTab} 
//             onChange={handleTabChange}
//             sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
//           >
//             <Tab 
//               icon={<Check />} 
//               iconPosition="start" 
//               label={`Pending Verification (${enhancedAgreements.length})`} 
//             />
//             <Tab 
//               icon={<History />} 
//               iconPosition="start" 
//               label={`Verified - Waiting Approval (${enhancedVerifiedAgreements.length})`} 
//             />
//           </Tabs>

//           {activeTab === 0 && (
//             <>
//               {enhancedAgreements.length > 0 ? (
//                 <>
//                   <IPDCFinalTable
//                     ref={componentRef}
//                     data={enhancedAgreements}
//                     setData={setAgreements}
//                     selectedColumns={selectedColumns.length > 0 ? selectedColumns : importantColumns.filter(col => enhancedAgreements[0]?.hasOwnProperty(col)).concat('actions')}
//                     title={`Pending Agreements for Verification (${enhancedAgreements.length})`}
//                     hasAttachment={false}
//                   />
                  
//                   <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//                     <Button
//                       variant="contained"
//                       startIcon={<TableChart />}
//                       onClick={handleExportAllToExcel}
//                       disabled={enhancedAgreements.length === 0}
//                       sx={{ 
//                         whiteSpace: 'nowrap',
//                         backgroundColor: '#f5f5f5',
//                         color: '#000000',
//                         '&:hover': {
//                           backgroundColor: '#e0e0e0',
//                         },
//                         '&:disabled': {
//                           backgroundColor: '#f5f5f5',
//                           color: '#000000',
//                           opacity: 0.5,
//                         }
//                       }}
//                     >
//                       Export All Data ({enhancedAgreements.length} rows)
//                     </Button>
//                   </Box>
//                 </>
//               ) : (
//                 !error && (
//                   <Box sx={{ p: 3, textAlign: 'center' }}>
//                     <Typography variant="h6" color="textSecondary">
//                       No pending agreements found for verification.
//                     </Typography>
//                     <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
//                       All agreements have been processed or there are no agreements waiting for verification.
//                     </Typography>
//                   </Box>
//                 )
//               )}
//             </>
//           )}

//           {activeTab === 1 && (
//             <>
//               {loadingHistory ? (
//                 <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//                   <CircularProgress />
//                   <Typography sx={{ ml: 2 }}>Loading verified agreements...</Typography>
//                 </Box>
//               ) : enhancedVerifiedAgreements.length > 0 ? (
//                 <>
//                   <IPDCFinalTable
//                     ref={componentRef}
//                     data={enhancedVerifiedAgreements}
//                     setData={setVerifiedAgreements}
//                     selectedColumns={selectedColumns.length > 0 ? selectedColumns : importantColumns.filter(col => enhancedVerifiedAgreements[0]?.hasOwnProperty(col)).concat('actions')}
//                     title={`Verified Agreements - Waiting for Approval (${enhancedVerifiedAgreements.length})`}
//                     hasAttachment={false}
//                   />
                  
//                   <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//                     <Button
//                       variant="contained"
//                       startIcon={<TableChart />}
//                       onClick={handleExportAllToExcel}
//                       disabled={enhancedVerifiedAgreements.length === 0}
//                       sx={{ 
//                         whiteSpace: 'nowrap',
//                         backgroundColor: '#f5f5f5',
//                         color: '#000000',
//                         '&:hover': {
//                           backgroundColor: '#e0e0e0',
//                         },
//                         '&:disabled': {
//                           backgroundColor: '#f5f5f5',
//                           color: '#000000',
//                           opacity: 0.5,
//                         }
//                       }}
//                     >
//                       Export All Data ({enhancedVerifiedAgreements.length} rows)
//                     </Button>
//                   </Box>
//                 </>
//               ) : (
//                 <Box sx={{ p: 3, textAlign: 'center' }}>
//                   <Typography variant="h6" color="textSecondary">
//                     No verified agreements waiting for approval.
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
//                     Verified agreements waiting for approval will appear here.
//                   </Typography>
//                 </Box>
//               )}
//             </>
//           )}
//         </CardContent>
//       </Card>

//       {/* Reject Justification Modal */}
//       <Dialog 
//         open={rejectModalOpen} 
//         onClose={handleCloseRejectModal}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: '#ffebee', 
//           color: '#c62828',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1
//         }}>
//           <Close /> Reject Agreement
//         </DialogTitle>
//         <DialogContent sx={{ mt: 2 }}>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//             You are about to reject the following agreement:
//           </Typography>
//           <Box sx={{ 
//             p: 2, 
//             backgroundColor: '#f5f5f5', 
//             borderRadius: 1, 
//             mb: 3,
//             wordBreak: 'break-word'
//           }}>
//             <Typography variant="subtitle2" color="primary">
//               Agreement ID: {rejectingAgreement?.agreement_id || rejectingAgreement?.id || 'N/A'}
//             </Typography>
//             <Typography variant="body2">
//               Investor: {rejectingAgreement?.company_name || rejectingAgreement?.investor_name || 'N/A'}
//             </Typography>
//             <Typography variant="body2">
//               Park: {rejectingAgreement?.park_name || rejectingAgreement?.park_id || 'N/A'}
//             </Typography>
//           </Box>
          
//           <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
//             Rejection Justification <span style={{ color: 'red' }}>*</span>
//           </Typography>
//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             placeholder="Please provide a detailed reason for rejecting this agreement..."
//             value={rejectJustification}
//             onChange={(e) => {
//               setRejectJustification(e.target.value);
//               if (e.target.value.trim()) {
//                 setRejectJustificationError(false);
//               }
//             }}
//             error={rejectJustificationError}
//             helperText={rejectJustificationError ? "Justification is required" : "This justification will be saved to the agreement's description field"}
//             variant="outlined"
//             sx={{ mb: 2 }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button 
//             onClick={handleCloseRejectModal} 
//             disabled={isSubmittingReject}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleSubmitRejection} 
//             variant="contained"
//             color="error"
//             disabled={isSubmittingReject}
//             startIcon={isSubmittingReject ? <CircularProgress size={20} /> : <Close />}
//           >
//             {isSubmittingReject ? "Rejecting..." : "Confirm Reject"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }
//************************************* Truncated Disposal method in the table */
import { useEffect, useState, useRef } from "react";
import { 
  GetDataFromApiWithParams, 
  ExecutePostWithParams 
} from "../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../components/IPDCFinalTable";
import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import { Check, Close, Download, TableChart, History, Edit } from "@mui/icons-material";

export default function AgreementVerificationPage() {
  const [agreements, setAgreements] = useState([]);
  const [verifiedAgreements, setVerifiedAgreements] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const componentRef = useRef();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  
  // Reject modal state
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectingAgreement, setRejectingAgreement] = useState(null);
  const [rejectJustification, setRejectJustification] = useState("");
  const [rejectJustificationError, setRejectJustificationError] = useState(false);
  const [isSubmittingReject, setIsSubmittingReject] = useState(false);

  // Define important columns as a constant so it's available for both tabs
  const importantColumns = [
    'id', 'agreement_id', 'company_name', 'contact_person', 
    'upin', 'investment_type', 'status',
    'contract_issued_on', 'contract_period_in_months',
    'monthly_rent', 'employee_capacity',
    'production_capacity', 'export_capacity', 'security', 'advance_payment',
    'tin_no', 'park_name', 'ownership_type', 'payment_mode',
    'annual_mngmnt_service_fee', 'grace_period_ending_date', 
    'market_destination_display', 'disposal_method',
    'handover_date', 'rehandover_date', 'production_commencement_date', 
    'late_charge_fee_display'
  ];

  useEffect(() => {
    fetchPendingAgreements();
    fetchVerifiedAgreements();
  }, []);

  // Helper function to truncate text
  const truncateText = (text, maxLength = 7) => {
    if (!text) return text;
    const str = String(text);
    return str.length > maxLength ? str.substring(0, maxLength) + '...' : str;
  };

  const fetchPendingAgreements = async () => {
    try {
      setLoading(true);
      setError("");
      console.log("Fetching pending agreements from API...");
      
      const resultRow = await GetDataFromApiWithParams("agreements/pending/approval");
      console.log("Pending Agreements API Response:", resultRow);
      
      if (resultRow && Array.isArray(resultRow)) {
        console.log(`Total pending agreements received: ${resultRow.length}`);
        
        if (resultRow.length > 0) {
          console.log("First pending agreement sample:", resultRow[0]);
          
          // Process the data to handle JSON fields
          const processedData = resultRow.map(item => ({
            ...item,
            // Handle late_charge_fee if it's a JSON string or object
            late_charge_fee_display: item.late_charge_fee ? 
              (typeof item.late_charge_fee === 'object' ? 
                `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
                item.late_charge_fee) : 
              '0%',
            // Handle market_destination if it's an array
            market_destination_display: Array.isArray(item.market_destination) ? 
              item.market_destination.join(', ') : 
              item.market_destination || '',
            // Handle intl_brands_link if it's an array
            intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
              item.intl_brands_link.join(', ') : 
              item.intl_brands_link || '',
            // Truncate disposal_method to 7 characters
            disposal_method: truncateText(item.disposal_method, 7),
          }));
          
          setAgreements(processedData);
          
          // Set columns based on first item
          const availableColumns = importantColumns.filter(col => 
            processedData[0].hasOwnProperty(col) || col === 'actions'
          );
          
          console.log("Columns available for display:", availableColumns);
          setSelectedColumns([...availableColumns, 'actions']);
        } else {
          setAgreements([]);
          // Don't set error here, just empty state
        }
      } else {
        setError("No agreement data received from API.");
      }
    } catch (err) {
      console.error("Error fetching pending agreements:", err);
      setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  const fetchVerifiedAgreements = async () => {
    try {
      setLoadingHistory(true);
      console.log("Fetching verified agreements (waiting for approval) from API...");
      
      // Fetch agreements that are verified and waiting for approval
      const resultRow = await GetDataFromApiWithParams("agreements/waiting/approval");
      console.log("Verified Agreements (Waiting for Approval) API Response:", resultRow);
      
      if (resultRow && Array.isArray(resultRow)) {
        console.log(`Total verified agreements waiting for approval: ${resultRow.length}`);
        
        if (resultRow.length > 0) {
          console.log("First verified agreement sample:", resultRow[0]);
          console.log("Keys in verified agreement:", Object.keys(resultRow[0]));
          
          // Process the data to handle JSON fields
          const processedData = resultRow.map(item => ({
            ...item,
            late_charge_fee_display: item.late_charge_fee ? 
              (typeof item.late_charge_fee === 'object' ? 
                `${item.late_charge_fee.fee || 0}${item.late_charge_fee.rate_type || '%'}` : 
                item.late_charge_fee) : 
              '0%',
            market_destination_display: Array.isArray(item.market_destination) ? 
              item.market_destination.join(', ') : 
              item.market_destination || '',
            intl_brands_link_display: Array.isArray(item.intl_brands_link) ? 
              item.intl_brands_link.join(', ') : 
              item.intl_brands_link || '',
            // Truncate disposal_method to 7 characters
            disposal_method: truncateText(item.disposal_method, 7),
          }));
          
          setVerifiedAgreements(processedData);
          
          // If columns not set yet, set them from verified agreements
          if (selectedColumns.length === 0) {
            const availableColumns = importantColumns.filter(col => 
              processedData[0].hasOwnProperty(col)
            );
            console.log("Setting columns from verified agreements:", availableColumns);
            setSelectedColumns([...availableColumns, 'actions']);
          }
        } else {
          setVerifiedAgreements([]);
        }
      } else {
        console.log("No verified agreements found or invalid response");
        setVerifiedAgreements([]);
      }
    } catch (err) {
      console.error("Error fetching verified agreements:", err);
      setVerifiedAgreements([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  // Open reject modal with justification form
  const handleOpenRejectModal = (agreement) => {
    setRejectingAgreement(agreement);
    setRejectJustification("");
    setRejectJustificationError(false);
    setRejectModalOpen(true);
  };

  // Close reject modal
  const handleCloseRejectModal = () => {
    setRejectModalOpen(false);
    setRejectingAgreement(null);
    setRejectJustification("");
    setRejectJustificationError(false);
    setIsSubmittingReject(false);
  };

  // Submit rejection with justification
  const handleSubmitRejection = async () => {
    // Validate justification
    if (!rejectJustification.trim()) {
      setRejectJustificationError(true);
      return;
    }

    setRejectJustificationError(false);
    setIsSubmittingReject(true);

    try {
      const agreementId = rejectingAgreement.id || rejectingAgreement.agreement_id;
      if (!agreementId) {
        setError("Cannot reject: Agreement ID is missing");
        handleCloseRejectModal();
        return;
      }

      // Combine existing description with rejection justification
      const existingDescription = rejectingAgreement.description || "";
      const rejectionNote = `[REJECTED By Head ON ${new Date().toLocaleString()}] Reason: ${rejectJustification.trim()} ]`;
      const updatedDescription = existingDescription 
        ? `${existingDescription}\n\n${rejectionNote}`
        : rejectionNote;

      const updateData = {
        agreement_id: agreementId,
        action: "reject",
        remarks: `Agreement rejected by Operation Management Head. Reason: ${rejectJustification.trim()}`,
        verified_by: "operation_management_head",
        description: updatedDescription  // Add the description to be updated
      };

      console.log(`Sending reject with justification for agreement:`, agreementId);
      console.log("Update data:", updateData);
      
      const response = await ExecutePostWithParams("agreements/verify", updateData);
      
      if (response) {
        // Remove the rejected agreement from the list
        setAgreements(prev => prev.filter(item => 
          (item.id || item.agreement_id) !== agreementId
        ));
        setSuccess(`Agreement successfully rejected! Justification saved to description.`);
        setError("");
        
        setTimeout(() => setSuccess(""), 5000);
        console.log(`Agreement ${agreementId} rejected successfully with justification`);
        
        // Close modal
        handleCloseRejectModal();
      } else {
        setError("Failed to reject agreement. Server returned no response.");
        setSuccess("");
      }
    } catch (err) {
      console.error("Rejection error:", err);
      setError(`Error: ${err.message || "Unknown error during rejection"}`);
      setSuccess("");
    } finally {
      setIsSubmittingReject(false);
    }
  };

  const handleVerification = async (agreement, action) => {
    try {
      const agreementId = agreement.id || agreement.agreement_id;
      if (!agreementId) {
        setError("Cannot verify: Agreement ID is missing");
        return;
      }

      const updateData = {
        agreement_id: agreementId,
        action: action,
        remarks: `Agreement ${action}ed by Operation Management Head`,
        verified_by: "operation_management_head",
      };

      console.log(`Sending ${action} for agreement:`, agreementId);
      const response = await ExecutePostWithParams("agreements/verify", updateData);
      
      if (response) {
        setAgreements(prev => prev.filter(item => 
          (item.id || item.agreement_id) !== agreementId
        ));
        setSuccess(`Agreement successfully ${action === "verify" ? "verified" : "rejected"}!`);
        setError("");
        
        // Refresh verified agreements list if verified
        if (action === "verify") {
          fetchVerifiedAgreements();
        }
        
        setTimeout(() => setSuccess(""), 5000);
        
        console.log(`Agreement ${agreementId} ${action}ed successfully`);
      } else {
        setError(`Failed to ${action} agreement. Server returned no response.`);
        setSuccess("");
      }
    } catch (err) {
      console.error("Verification error:", err);
      setError(`Error: ${err.message || "Unknown error during verification"}`);
      setSuccess("");
    }
  };

  const handleAllowEdit = async (agreement) => {
    try {
      const agreementId = agreement.id || agreement.agreement_id;
      if (!agreementId) {
        setError("Cannot allow edit: Agreement ID is missing");
        return;
      }

      console.log(`Allowing edit for agreement: ${agreementId}`);
      
      const updateData = {
        agreement_id: agreementId,
        action: "allow_edit",
        remarks: "Edit access granted to expert by Operation Management Head",
        verified_by: "operation_management_head",
      };

      console.log("Sending allow_edit request:", updateData);
      
      const response = await ExecutePostWithParams("agreements/verify", updateData);
      
      if (response) {
        setVerifiedAgreements(prev => prev.filter(item => 
          (item.id || item.agreement_id) !== agreementId
        ));
        setSuccess(`Edit access granted for agreement ${agreementId}!`);
        setError("");
        setTimeout(() => setSuccess(""), 5000);
        console.log(`Edit allowed for agreement ${agreementId}`);
      } else {
        setError("Failed to allow edit. Please try again.");
        setSuccess("");
      }
    } catch (err) {
      console.error("Allow edit error:", err);
      setError(`Error: ${err.message || "Unknown error while allowing edit"}`);
      setSuccess("");
    }
  };

  const handleExportToExcel = (agreement) => {
    try {
      // Create a clean copy without React components and processed display fields
      const exportData = { ...agreement };
      
      // Remove React components and display fields
      delete exportData.actions;
      delete exportData.market_destination_display;
      delete exportData.intl_brands_link_display;
      delete exportData.late_charge_fee_display;
      
      // Handle JSON fields for export
      if (exportData.late_charge_fee) {
        if (typeof exportData.late_charge_fee === 'object') {
          exportData.late_charge_fee = `${exportData.late_charge_fee.fee || 0}${exportData.late_charge_fee.rate_type || '%'}`;
        }
      }
      
      // Handle array fields for export
      if (Array.isArray(exportData.market_destination)) {
        exportData.market_destination = exportData.market_destination.join(', ');
      }
      if (Array.isArray(exportData.intl_brands_link)) {
        exportData.intl_brands_link = exportData.intl_brands_link.join(', ');
      }
      
      const headers = Object.keys(exportData).filter(key => 
        typeof exportData[key] !== 'object' || exportData[key] === null
      );
      
      const csvHeaders = headers.join(',');
      const csvRow = headers.map(header => {
        const value = exportData[header];
        if (value === null || value === undefined) return '';
        // Handle values that might contain commas by wrapping in quotes
        return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
      }).join(',');
      
      const csvContent = `${csvHeaders}\n${csvRow}`;
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
    } catch (err) {
      console.error("Error exporting to Excel:", err);
      setError("Error exporting agreement data to Excel");
    }
  };

  const handleExportAllToExcel = () => {
    try {
      const dataToExport = activeTab === 0 ? enhancedAgreements : enhancedVerifiedAgreements;
      
      if (dataToExport.length === 0) {
        setError("No data to export");
        return;
      }

      // Create export data without React components
      const exportData = dataToExport.map(agreement => {
        const cleanData = { ...agreement };
        
        // Remove React components and display fields
        delete cleanData.actions;
        delete cleanData.market_destination_display;
        delete cleanData.intl_brands_link_display;
        delete cleanData.late_charge_fee_display;
        
        // Handle JSON fields
        if (cleanData.late_charge_fee) {
          if (typeof cleanData.late_charge_fee === 'object') {
            cleanData.late_charge_fee = `${cleanData.late_charge_fee.fee || 0}${cleanData.late_charge_fee.rate_type || '%'}`;
          }
        }
        
        // Handle array fields
        if (Array.isArray(cleanData.market_destination)) {
          cleanData.market_destination = cleanData.market_destination.join(', ');
        }
        if (Array.isArray(cleanData.intl_brands_link)) {
          cleanData.intl_brands_link = cleanData.intl_brands_link.join(', ');
        }
        
        return cleanData;
      });

      const headers = Object.keys(exportData[0]).filter(key => 
        typeof exportData[0][key] !== 'object' || exportData[0][key] === null
      );
      
      const csvHeaders = headers.join(',');
      
      const csvRows = exportData.map(item => {
        return headers.map(header => {
          const value = item[header];
          if (value === null || value === undefined) return '';
          return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
        }).join(',');
      }).join('\n');
      
      const csvContent = `${csvHeaders}\n${csvRows}`;
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      const tabLabel = activeTab === 0 ? 'pending' : 'verified_waiting_approval';
      link.setAttribute('href', url);
      link.setAttribute('download', `all_${tabLabel}_agreements_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log(`Exported all ${dataToExport.length} agreements to Excel`);
      setSuccess(`All ${dataToExport.length} agreements exported successfully!`);
      setTimeout(() => setSuccess(""), 5000);
    } catch (err) {
      console.error("Error exporting all to Excel:", err);
      setError("Error exporting all agreements data to Excel");
    }
  };

  // Enhanced agreements with action buttons and formatted display values
  const enhancedAgreements = agreements.map(agreement => {
    const agreementId = agreement.id || agreement.agreement_id;
    const status = agreement.status || agreement.contract_status || 'Pending';
    
    // Format late_charge_fee for display
    let lateChargeDisplay = '';
    if (agreement.late_charge_fee) {
      if (typeof agreement.late_charge_fee === 'object') {
        lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
      } else {
        lateChargeDisplay = agreement.late_charge_fee;
      }
    }
    
    return {
      ...agreement,
      id: agreementId,
      status: status,
      // Use the display values instead of raw JSON/array data
      late_charge_fee: lateChargeDisplay,
      market_destination: agreement.market_destination_display || agreement.market_destination,
      intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
      // disposal_method is already truncated in the data processing
      actions: (
        <Box sx={{ 
          display: "flex", 
          gap: 1, 
          flexDirection: 'row',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<Download />}
            onClick={() => handleExportToExcel(agreement)}
            disabled={!agreementId}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Export
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={<Check />}
            onClick={() => handleVerification(agreement, "verify")}
            disabled={!agreementId}
            sx={{ 
              whiteSpace: 'nowrap',
              backgroundColor: '#f5f5f5',
              color: '#000000',
              '&:hover': {
                backgroundColor: '#e0e0e0',
              }
            }}
          >
            Verify
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={<Close />}
            onClick={() => handleOpenRejectModal(agreement)}
            disabled={!agreementId}
            sx={{ 
              whiteSpace: 'nowrap',
              backgroundColor: '#FFFafa',
              color: '#000000',
              '&:hover': {
                backgroundColor: '#F08090',
              }
            }}
          >
            Reject
          </Button>
        </Box>
      )
    };
  });

  // Enhanced verified agreements with action buttons
  const enhancedVerifiedAgreements = verifiedAgreements.map(agreement => {
    const agreementId = agreement.id || agreement.agreement_id;
    
    // Format late_charge_fee for display
    let lateChargeDisplay = '';
    if (agreement.late_charge_fee) {
      if (typeof agreement.late_charge_fee === 'object') {
        lateChargeDisplay = `${agreement.late_charge_fee.fee || 0}${agreement.late_charge_fee.rate_type || '%'}`;
      } else {
        lateChargeDisplay = agreement.late_charge_fee;
      }
    }
    
    return {
      ...agreement,
      id: agreementId,
      late_charge_fee: lateChargeDisplay,
      market_destination: agreement.market_destination_display || agreement.market_destination,
      intl_brands_link: agreement.intl_brands_link_display || agreement.intl_brands_link,
      // disposal_method is already truncated in the data processing
      actions: (
        <Box sx={{ 
          display: "flex", 
          gap: 1, 
          flexDirection: 'row',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Button
            variant="contained"
            size="small"
            startIcon={<Edit />}
            onClick={() => handleAllowEdit(agreement)}
            disabled={!agreementId}
            sx={{ 
              whiteSpace: 'nowrap',
              backgroundColor: '#4caf50',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#388e3c',
              }
            }}
          >
            Allow Edit
          </Button>
        </Box>
      )
    };
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setError("");
    setSuccess("");
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
              {success}
            </Alert>
          )}

          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab 
              icon={<Check />} 
              iconPosition="start" 
              label={`Pending Verification (${enhancedAgreements.length})`} 
            />
            <Tab 
              icon={<History />} 
              iconPosition="start" 
              label={`Verified - Waiting Approval (${enhancedVerifiedAgreements.length})`} 
            />
          </Tabs>

          {activeTab === 0 && (
            <>
              {enhancedAgreements.length > 0 ? (
                <>
                  <IPDCFinalTable
                    ref={componentRef}
                    data={enhancedAgreements}
                    setData={setAgreements}
                    selectedColumns={selectedColumns.length > 0 ? selectedColumns : importantColumns.filter(col => enhancedAgreements[0]?.hasOwnProperty(col)).concat('actions')}
                    title={`Pending Agreements for Verification (${enhancedAgreements.length})`}
                    hasAttachment={false}
                  />
                  
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button
                      variant="contained"
                      startIcon={<TableChart />}
                      onClick={handleExportAllToExcel}
                      disabled={enhancedAgreements.length === 0}
                      sx={{ 
                        whiteSpace: 'nowrap',
                        backgroundColor: '#f5f5f5',
                        color: '#000000',
                        '&:hover': {
                          backgroundColor: '#e0e0e0',
                        },
                        '&:disabled': {
                          backgroundColor: '#f5f5f5',
                          color: '#000000',
                          opacity: 0.5,
                        }
                      }}
                    >
                      Export All Data ({enhancedAgreements.length} rows)
                    </Button>
                  </Box>
                </>
              ) : (
                !error && (
                  <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography variant="h6" color="textSecondary">
                      No pending agreements found for verification.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                      All agreements have been processed or there are no agreements waiting for verification.
                    </Typography>
                  </Box>
                )
              )}
            </>
          )}

          {activeTab === 1 && (
            <>
              {loadingHistory ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                  <CircularProgress />
                  <Typography sx={{ ml: 2 }}>Loading verified agreements...</Typography>
                </Box>
              ) : enhancedVerifiedAgreements.length > 0 ? (
                <>
                  <IPDCFinalTable
                    ref={componentRef}
                    data={enhancedVerifiedAgreements}
                    setData={setVerifiedAgreements}
                    selectedColumns={selectedColumns.length > 0 ? selectedColumns : importantColumns.filter(col => enhancedVerifiedAgreements[0]?.hasOwnProperty(col)).concat('actions')}
                    title={`Verified Agreements - Waiting for Approval (${enhancedVerifiedAgreements.length})`}
                    hasAttachment={false}
                  />
                  
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button
                      variant="contained"
                      startIcon={<TableChart />}
                      onClick={handleExportAllToExcel}
                      disabled={enhancedVerifiedAgreements.length === 0}
                      sx={{ 
                        whiteSpace: 'nowrap',
                        backgroundColor: '#f5f5f5',
                        color: '#000000',
                        '&:hover': {
                          backgroundColor: '#e0e0e0',
                        },
                        '&:disabled': {
                          backgroundColor: '#f5f5f5',
                          color: '#000000',
                          opacity: 0.5,
                        }
                      }}
                    >
                      Export All Data ({enhancedVerifiedAgreements.length} rows)
                    </Button>
                  </Box>
                </>
              ) : (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant="h6" color="textSecondary">
                    No verified agreements waiting for approval.
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    Verified agreements waiting for approval will appear here.
                  </Typography>
                </Box>
              )}
            </>
          )}
        </CardContent>
      </Card>

      {/* Reject Justification Modal */}
      <Dialog 
        open={rejectModalOpen} 
        onClose={handleCloseRejectModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          backgroundColor: '#ffebee', 
          color: '#c62828',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <Close /> Reject Agreement
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            You are about to reject the following agreement:
          </Typography>
          <Box sx={{ 
            p: 2, 
            backgroundColor: '#f5f5f5', 
            borderRadius: 1, 
            mb: 3,
            wordBreak: 'break-word'
          }}>
            <Typography variant="subtitle2" color="primary">
              Agreement ID: {rejectingAgreement?.agreement_id || rejectingAgreement?.id || 'N/A'}
            </Typography>
            <Typography variant="body2">
              Investor: {rejectingAgreement?.company_name || rejectingAgreement?.investor_name || 'N/A'}
            </Typography>
            <Typography variant="body2">
              Park: {rejectingAgreement?.park_name || rejectingAgreement?.park_id || 'N/A'}
            </Typography>
          </Box>
          
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
            Rejection Justification <span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Please provide a detailed reason for rejecting this agreement..."
            value={rejectJustification}
            onChange={(e) => {
              setRejectJustification(e.target.value);
              if (e.target.value.trim()) {
                setRejectJustificationError(false);
              }
            }}
            error={rejectJustificationError}
            helperText={rejectJustificationError ? "Justification is required" : "This justification will be saved to the agreement's description field"}
            variant="outlined"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button 
            onClick={handleCloseRejectModal} 
            disabled={isSubmittingReject}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmitRejection} 
            variant="contained"
            color="error"
            disabled={isSubmittingReject}
            startIcon={isSubmittingReject ? <CircularProgress size={20} /> : <Close />}
          >
            {isSubmittingReject ? "Rejecting..." : "Confirm Reject"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}